import React from 'react'
import { useState } from 'react';
import {Link} from 'gatsby'

import { graphql, useStaticQuery } from "gatsby"
import { Bar } from 'react-chartjs-2'

import { getBaseChartBarLine } from './ChartUtils'
import CmpFilterList from "./CmpFilterList"

const RptAnualXTarifas = (props) => {
  const [filter, setFilter] =  useState(null);//useState({key: 'Puebla', label: 'Tiendas y Ocio'});
  const [chartType, setChartType] =  useState('line');
  const [sortBy, setSortBy] =  useState(null);
  const [filters, setFilters] = useState({'filter2': [], 'filter3': [], 'filter4': []})
  const [filterData, setFilterData] = useState(null)  
  
  function onFiltersLoaded(loadedFilters, e){
    setFilters(loadedFilters)
  }

  function applyDataFilter(filterName, value){
    setFilterData({filterName: filterName, value: value})
  }    

  function onFilterSelected(vfilter, e){
    setFilter(vfilter);
  }

  function sort(e){
    setSortBy(sortBy + 1);
    e.preventDefault();
  }

  return(
    
    <div className="row">  

      <div className="col-lg-12">
        <div className="rpt-chart-types">
            <a className="default-btn small" href="#/" onClick={(e) => {setChartType('bar'); e.preventDefault();} }><i className="flaticon-view"></i>Bar</a>
            <a className="default-btn small" href="#/" onClick={(e) => {setChartType('line'); e.preventDefault();} }><i className="flaticon-view"></i>Line</a>
            <a className="default-btn small" href="#/" onClick={sort}><i className="flaticon-up"></i>Sort</a>
        </div>        
        <TheChart value="" filter={filter} chartType={`${chartType}`}  sortBy={sortBy} onFiltersLoaded={onFiltersLoaded} filterData={filterData}/>
      </div>

      <div className="col-lg-12">
      <div className="widget-area small row" style={{'margin-top': '1.5em'}}>          
            <div className="widget widget_tag_cloud col-lg-4">

                <h3 className="widget-title">Región geográfica</h3>                
                <div className="tagcloud">
                  <Link to="#" onClick={(e) => {applyDataFilter('filter2', null); e.preventDefault();} }> Todos </Link>                

                  {filters['filter2'].map((item) => {
                  return <Link to="#" onClick={(e) => {applyDataFilter('filter2', item); e.preventDefault();} }> {item} </Link>
                  })}
                </div>
            </div>

            <div className="widget widget_tag_cloud col-lg-4">
                <h3 className="widget-title">Ciudad turística de playa</h3>                
                <div className="tagcloud">
                  <Link to="#" onClick={(e) => {applyDataFilter('filter3', null); e.preventDefault();} }> Todos </Link>

                  {filters['filter3'].map((item) => {
                  return <Link to="#" onClick={(e) => {applyDataFilter('filter3', item); e.preventDefault();} }> {item} </Link>
                  })}
                </div>                
            </div>

            <div className="widget widget_tag_cloud col-lg-4">
                <h3 className="widget-title">Grandes ciudades</h3>                
                <div className="tagcloud">
                  <Link to="#" onClick={(e) => {applyDataFilter('filter4', null); e.preventDefault();} }> Todos </Link>

                  {filters['filter4'].map((item) => {
                  return <Link to="#" onClick={(e) => {applyDataFilter('filter4', item); e.preventDefault();} }> {item} </Link>
                  })}
                </div>                
            </div>

      </div>        
      </div>

    </div>    
  )

}


export default RptAnualXTarifas


// ====================== The chart

// export const query_bak = graphql`

//   fragment metadataAnualTarifas on BdanualCsv {
//     label: Entidad    
//     filter: Entidad
//     filter2: Region_Geografica
//     filter3: Ciudades_Turisticas_de_Playa
//     filter4: Grandes_Ciudades
//   }

//   {
//     bd: allBdanualCsv(sort: {fields: Entidad}) {
//         Tarifas_2019: nodes {
//           data: Tarifas_2019
//           ...metadataAnualTarifas
//         }
//         Tarifas_2020: nodes {
//           data: Tarifas_2020
//           ...metadataAnualTarifas
//         }
//       }


//     filters: allBdanualCsv(
//       sort: {fields: Region_Geografica}
//     ) {        
//         filter2: distinct(field: Region_Geografica)
//         filter3: distinct(field: Ciudades_Turisticas_de_Playa)
//         filter4: distinct(field: Grandes_Ciudades)
//     }

//   }
// `

export const query = graphql`

  {

    bd: allBdanualTarifasCsv{
      series: group(field: Periodo) {
        name: fieldValue
        Tarifas: nodes{
          label: Entidad
          data: Tarifa
          filter: Entidad
          filter2: Region_Geografica
          filter3: Ciudades_Turisticas_de_Playa
          filter4: Grandes_Ciudades
        }
      }  
    }


    filters: allBdanualTarifasCsv(
        sort: {fields: Region_Geografica}
      ) {        
          filter2: distinct(field: Region_Geografica)
          filter3: distinct(field: Ciudades_Turisticas_de_Playa)
          filter4: distinct(field: Grandes_Ciudades)
      }

  }
`

const TheChart = (props) => {
    const dataRs = useStaticQuery(query)    
    const { filters: filters} = dataRs

    // [owl:20210725] To easily add new anual "Tarifas"
    const { bd: bd} = dataRs
    const { series: series} = bd
    let data = {bd: {}}
    series.forEach(serie => {
      data.bd["Tarifas_" + serie.name] = serie.Tarifas
    });

    props.onFiltersLoaded(filters) // notify loaded filters    

    let sortBy = props.hasOwnProperty('sortBy') ? props.sortBy : null;  //(a, b) => a.data - b.data;
    let chart = getBaseChartBarLine(data, props.filter ? props.filter : props.filterData ? props.filterData : null, props.chartType, false, false, sortBy)

    return(
        <div className="rpt-chart">            
            <h4>{chart.title}</h4>
            {/* <Bar data={chart.data} options={{ legend: {position: 'top'} }}/> */}
            <Bar data={chart.data} options={{ legend: {position: 'top'}, scales: { yAxes: [ {ticks: { beginAtZero: true   } } ] } }}/>

        </div>
    )
}

